<template>
    <div class="row">
      <div class="col-md-12">
        <div class="card vx-card">
          <div class="card-body" v-loading="loading">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
                <registers-per-page
                  @changeNumPerPage="changeNumPerPage"
                ></registers-per-page>
                <search-filter
                  @executeSearch="search"
                  :options="[]"
                ></search-filter>
              </div>
            </div>
  
            <div
              id="data-list-list-view"
              class="data-list-container mt-5"
              v-if="items.length"
            >
              <vs-table ref="table" :max-items="perPage" :data="items">
                <template slot="thead">
                  <vs-th>Código</vs-th>
                  <vs-th>Nombre</vs-th>
                  <vs-th>Código de Barras</vs-th>
                  <vs-th>Precio</vs-th>
                  <vs-th>Acciones</vs-th>
                </template>
  
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="item"
                      :key="indextr"
                      v-for="(item, indextr) in data"
                    >
                      <vs-td>
                        {{ item.code }}
                      </vs-td>
  
                      <vs-td>
                        {{ item.name | truncateText(0, 25) }}
                      </vs-td>

                      <vs-td>
                        {{ item.barcode }}
                      </vs-td>
  
                      <vs-td> {{ item.currency.symbol }} {{ item.price }} </vs-td>
  
                      <vs-td class="whitespace-no-wrap">
                      <el-dropdown @command="itemAction">
                        <i class="fa fa-cogs text-primary"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            :command="{ action: 'print', id: item.id }"
                            class="text-success"
                          >
                            <i class="fa fa-print"></i>
                            Imprimir
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
  
              <div
                class="mt-4 text-center zatura-pagination"
                v-if="pageCount > 1"
              >
                <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
              </div>
            </div>
  
            <div
              class="col-md-12 text-center"
              v-if="!loading && items.length == 0"
            >
              <p>No hay artículos.</p>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import itemsService from "@/services/items.service.js";
  import brandsService from "@/services/brands.service.js";
  import SearchFilter from "@/components/SearchFilter.vue";
  import RegistersPerPage from "@/components/RegistersPerPage";
  import { mapState, mapActions } from "vuex";
  import Modal from "@/components/Modal.vue";
  import utilitiesService from "@/services/utilities.service";
  import Config from "@/config";
  import helpers from "@/helpers/helpers";
  
  export default {
    name: "items-labels",
    data() {
      return {
        cabysCodes: [],
  
        items: [],
        loadingSearch: false,
        loading: true,
        pageCount: 1,
        perPage: 10,
        page: 1,
        searchData: {},
        item: {
          cabys_code: "",
          code: "",
          name: "",
          description: "",
          category: {id: 1, name: "Productos"},
          unit: {id: 37, name: "Unidad"},
          tax_type: "",
          price: "",
          currency: {id: 2, name: "Colones"},
          sku: "",
          barcode: "",
          reference: "",
          max_discount: "",
          brand: "",
          cost_price: "",
          sale_price: "",
          stock: "",
          utility: "",
          has_inventory: false,
          active: true
        },
        brands: [],
      };
    },
    computed: {
      ...mapState(["categories", "units", "tax_types", "currencies"]),
      categories() {
        return this.$store.state.categories;
      },
      units() {
        return this.$store.state.units;
      },
      tax_types() {
        return this.$store.state.tax_types;
      },
      currencies() {
        return this.$store.state.currencies;
      }
    },
    methods: {
      ...mapActions([
        "getCategories",
        "getUnits",
        "getTaxTypes",
        "getCurrencies"
      ]),
      changeNumPerPage(num) {
        let searchData = this.searchData;
        searchData.perPage = num;
        this.searchData = searchData;
        this.getItems(1, this.searchData);
      },
      search(search) {
        this.searchData = search;
        this.searchData.perPage = this.perPage;
        this.getItems(1, this.searchData);
      },
      getItems(page = 1, search = {}) {
        this.loading = true;
  
        itemsService
          .getItems(page, search)
          .then(res => {
            this.items = res.data.data;
            this.loading = false;
            this.pageCount = res.data.last_page;
          })
          .catch(error => {
            this.loading = false;
            if (error.response.status == 401) {
              // localStorage.clear();
              // this.$router.push('login');
            }
          });
      },
      getBrands(page = 0) {
        brandsService
          .getBrands(page)
          .then(res => {
            this.brands = res.data;
          })
          .catch(error => {
            this.loading = false;
            if (error.response.status == 401) {
              // localStorage.clear();
              // this.$router.push('login');
            }
          });
      },
      getPrice() {
        if (this.item.tax_type && this.item.sale_price != ""){
          let price = this.item.sale_price * 100 / (100 + this.item.tax_type.rate * 1);
          this.item.price = price.toFixed(2);
        }
      },
      getUtility() {
        if (this.item.tax_type && this.item.price != ""){
          let sale_price = (this.item.price * 1 + (this.item.price * this.item.tax_type.rate / 100));
          this.item.sale_price = sale_price.toFixed(2);
        }
        if (
          this.item.cost_price != "" &&
          this.item.cost_price > 0 &&
          this.item.price != ""
        ) {
          let result = (this.item.price / this.item.cost_price - 1) * 100;
          this.item.utility = result.toFixed(2);
        }
      },
      resetForm() {
        let data_form_initial = this.$options.data().item;
        Object.assign(this.$data.item, data_form_initial);
        this.$validator.reset();
      },
      newItem() {
        this.resetForm();
        this.newItemModal = true;
        //this.$router.push('new-item')
      },
      goPage(numPage) {
        this.getItems(numPage, this.searchData);
      },
      refresh() {
        this.getItems(1, this.searchData);
        this.newItemModal = false;
      },
      getItemDetail(id) {
        itemsService
          .getItemDetail(id)
          .then(res => {
            this.item = res.data.item;
            this.item.has_inventory = this.item.has_inventory == 1 ? true : false;
            this.item.active = this.item.active == 1 ? true : false;
            if (this.item.cabys_code) this.cabysCodes.push(this.item.cabys_code);
            this.getUtility();
          })
          .catch(error => {
            //this.$snotify.error(error.response.data.message);
            //JRA Cambio de notificacion por mensaje
            this.$message({
              showClose: true,
              message: error.response.data.message,
              type: "error"
            });
          });
      },
      getCategories() {
        this.$store.dispatch("getCategories", {});
      },
      getUnits() {
        this.$store.dispatch("getUnits", {});
      },
      getTaxTypes() {
        this.$store.dispatch("getTaxTypes", {});
      },
      getCurrencies() {
        this.$store.dispatch("getCurrencies", {});
      },
      searchCabysCodes(search) {
        this.loadingSearch = true;
        this.getCabysCodes(search);
      },
      //Get cabys codes
      getCabysCodes(search = false) {
        utilitiesService
          .getCabysCodes(search)
          .then(res => {
            this.loadingSearch = false;
            this.cabysCodes = res.data;
          })
          .catch(error => {
            this.loadingSearch = false;
            this.$message({
              showClose: true,
              message: error.response.data.message,
              type: "error"
            });
          });
      },
      changeTaxType(val) {
        let tt = this.tax_types.find(i => i.name == "Exento");
        if (val.tax_rate != "Exento") {
          tt = this.tax_types.find(i => i.rate == val.tax_rate);
        }
        this.item.tax_type = tt;
      }
    },
    watch: {
      page(newVal) {
        this.goPage(newVal);
      }
    },
    created() {
      this.getItems();
      this.getCategories();
      this.getUnits();
      this.getTaxTypes();
      this.getCurrencies();
      this.getCabysCodes();
      this.getBrands();
    },
    components: {
      SearchFilter,
      RegistersPerPage,
      Modal,
    }
  };
  </script>
  
  <style>
  .box-shadow {
    box-shadow: 0 0 2px rgb(136, 124, 124) !important;
  }
  
  .oculto {
    display: none;
  }
  
  .con-vs-popup .vs-popup {
    width: 700px !important;
  }
  
  .el-select-dropdown__item {
    max-width: 600px;
    position: static;
    white-space: break-spaces;
    text-overflow: none;
    /* height: auto !important; */
    height: auto;
    max-height: 60px;
  }
  </style>
  